import { Appearance } from "@stripe/stripe-js";
import { theme } from "../../../theme/theme";

const colors = theme.colors as Record<string, Record<string, string>>;

// `inputs` and `labels` are documented in Stripe's Appearance API but absent
// from the SDK's TypeScript surface, so we cast through this extended type.
type StripeAppearance = Appearance & {
  inputs?: "spaced" | "condensed";
  labels?: "auto" | "above" | "floating";
};

export const stripeAppearance: StripeAppearance = {
  theme: "night",
  // Group related fields (Card number / Exp / CVC) without inter-field spacing.
  // With `condensed`, labels float inside the inputs by default.
  inputs: "condensed",
  labels: "floating",
  variables: {
    colorPrimary: colors.blaze.blaze,
    colorBackground: "#1c1d20",
    colorDanger: colors.error["300"],
    fontFamily: "Roboto, sans-serif",
    fontSizeBase: "16px",
    borderRadius: "16px",
    spacingUnit: "4px",
    gridRowSpacing: "16px",
    gridColumnSpacing: "12px",
    iconColor: "rgba(255,255,255,0.45)",
    focusBoxShadow: "0 0 0 3px rgba(255,90,44,0.35)",
    focusOutline: "none",
  },
  rules: {
    ".Input": {
      padding: "14px 16px",
      fontSize: "15px",
      lineHeight: "1.4",
    },
    ".Label": {
      fontWeight: "500",
      letterSpacing: "0.01em",
    },
    ".Block": {
      padding: "16px",
    },
  },
};
